function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "g10",
  transform: "matrix(1.25,0,0,-1.25,0,67.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g12",
  transform: "scale(0.1,0.1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path14",
  d: "M1298.2,220.8l39.3,68l39.3-68H1298.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "path16",
  d: "M1416,288.9l-39.3-68l-39.3,68H1416"
}), /*#__PURE__*/React.createElement("path", {
  id: "path18",
  d: "M1337.4,288.9l-39.3-68l-39.3,68H1337.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "path20",
  d: "M1376.7,356.9l-39.3-68l-39.3,68H1376.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "path22",
  d: "M1258.9,288.9l39.3,68l39.3-68H1258.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "path24",
  d: "M1337.4,288.9l39.3,68l39.3-68H1337.4"
}), /*#__PURE__*/React.createElement("path", {
  id: "path48",
  d: "M24,500h74.8l97.1-172.3h0.8V500h68.5V220.4h-74.8L93.3,394.7h-0.8V220.4H24V500"
}), /*#__PURE__*/React.createElement("path", {
  id: "path50",
  d: "M433.9,343c-1.2,22.7-17.2,41.5-39.5,41.5c-23.5,0-39.2-16.8-43.1-41.5 C351.3,343,433.9,343,433.9,343z M351.3,305.8c1.2-27.8,17.2-46.2,45.4-46.2c16.1,0,31.7,7.4,38,22.3H497 c-12.1-47-55.6-67.3-101-67.3c-66.2,0-111.2,39.9-111.2,108.1c0,62.3,49.7,106.9,109.6,106.9c72.8,0,109.2-54.8,106.1-123.7H351.3 "
}), /*#__PURE__*/React.createElement("path", {
  id: "path52",
  d: "M638.7,380.6h-41.1v-92.4c0-16.1,9.4-19.6,23.9-19.6c5.5,0,11.4,0.8,17.2,0.8v-48.9 c-12.1-0.4-24.3-2-36.4-2c-56.8,0-71.3,16.4-71.3,71.6v90.4h-33.7v43.1H531v61.5h66.6v-61.5h41.1V380.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "path54",
  d: "M773.3,380.6h-41.1v-92.4c0-16.1,9.4-19.6,23.9-19.6c5.5,0,11.3,0.8,17.2,0.8v-48.9 c-12.1-0.4-24.3-2-36.4-2c-56.8,0-71.3,16.4-71.3,71.6v90.4H632v43.1h33.7v61.5h66.6v-61.5h41.1V380.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "path56",
  d: "M932.7,343c-1.2,22.7-17.2,41.5-39.5,41.5c-23.5,0-39.2-16.8-43.1-41.5 C850.1,343,932.7,343,932.7,343z M850.1,305.8c1.2-27.8,17.2-46.2,45.4-46.2c16.1,0,31.7,7.4,38,22.3h62.3 c-12.1-47-55.6-67.3-101-67.3c-66.2,0-111.2,39.9-111.2,108.1c0,62.3,49.7,106.9,109.6,106.9c72.8,0,109.2-54.8,106.1-123.7H850.1 "
}), /*#__PURE__*/React.createElement("path", {
  id: "path58",
  d: "M1079.5,324.2c0-27.8,10.2-58.7,40.7-58.7c32.5,0,39.5,30.9,39.5,56.8 c0,29.4-10.6,56.4-39.5,56.4C1089.7,378.6,1079.5,350,1079.5,324.2z M1224,220.4h-63.4v23.5h-0.8c-12.9-19.2-32.5-29.4-56-29.4 c-63.8,0-90.8,54.8-90.8,112c0,52.9,28.2,103,85.8,103c25.1,0,44.2-9.4,57.9-27.8h0.8V500h66.6V220.4"
})));

var SvgNettedLogo = function SvgNettedLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 181 44",
    style: {
      enableBackground: "new 0 0 181 44"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNettedLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Netted-Logo.f17b93ef.svg";
export { ForwardRef as ReactComponent };